import { Permission, useCurrentUser, usePermission } from '@bonusly/who-am-i';

import { useMyTeamRequests } from '../../../queries/team-requests';
import { useCurrentUserReports } from '../../team-management/hooks/use-current-user-reports';

export const useHasNoTeamContent = () => {
	const canAccessTeamHub = usePermission(Permission.CanAccessTeamHub);
	const canManageTeamRequests = usePermission(Permission.CanManageTeamRequests);
	const user = useCurrentUser();
	const { data: directReports = [], isLoading: isLoadingReports } = useCurrentUserReports();
	const { data: myRequestsData, isLoading: isLoadingRequests } = useMyTeamRequests({ enabled: canManageTeamRequests });

	if (isLoadingReports || isLoadingRequests) return false;

	const hasActiveRequests = (myRequestsData?.records ?? []).some((r) => r.state !== 'cancelled' && r.state !== 'approved' && r.state !== 'declined');

	return !canAccessTeamHub && !user.manager_id && directReports.length === 0 && !hasActiveRequests;
};
